export const EN = 'en';
export const FA = 'fa';
export const LTR = 'ltr';
export const RTL = 'rtl';
export const PARTS = 'parts';
export const MOLDS = 'molds';
export const EMPLOYERS = 'employers';
